import { useContext } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import NearbyToursModal from 'tripPlanner/components/TripModal/ViewMoreOffers/NearbyToursModal'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  lat: number
  lng: number
  className?: string
  item: TripItem
  showSearch: boolean
}

function ViewNearbyToursCta({ lat, lng, item, className, showSearch }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  return (
    <TextButton
      kind="secondary"
      size="medium"
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showModal(
          <NearbyToursModal
            lat={lat}
            lng={lng}
            item={item}
            showSearch={showSearch}
          />,
        )
      }}
    >
      {intl.formatMessage({
        id: 'j9M-KCgxJ2y4yeJbYlLk',
        defaultMessage: 'View more offers',
        description: 'Action button to view nearby tour offers for a trip item',
      })}
    </TextButton>
  )
}

export default ViewNearbyToursCta
